module.exports = __webpack_public_path__ + "img/Gartenzimmer.2bd179f4.svg";